module.exports = __webpack_public_path__ + "static/img/207.4698ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/207.png
// module id = 7DU4
// module chunks = 0